import Control from "ol/control/Control";
import * as msal from "@azure/msal-browser";
import { getMsalObjPromise } from "../auth/getMsalObj";

// ID tokens are short-lived (~60-90 min). Re-acquiring silently on this
// interval keeps AzureLoginControl's idToken/idTokenClaims fresh for
// consumers (WFSLayer, SDOLayer, DirectionalLayers, BoundaryCodesControl,
// HeatmapLayersAndControls) that read a cached token instead of asking MSAL
// per-request the way monkeyFetch.js does.
const TOKEN_REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export class AzureLoginControl extends Control {
  constructor() {
    const div = document.createElement("div");
    div.className = "login";
    super({ element: div });
    const this_ = this;

    function refreshToken(msalObj) {
      const account = msalObj.getAllAccounts()[0];
      const request = {
        account: account,
        scopes: ["https://storage.azure.com/user_impersonation"],
      };
      return msalObj
        .acquireTokenSilent(request)
        .then(function (tokenResponse) {
          this_.set("idToken", tokenResponse.idToken);
          this_.set("idTokenClaims", tokenResponse.idTokenClaims);
        })
        .catch(function (error) {
          console.log(error);
          if (
            error instanceof msal.InteractionRequiredAuthError ||
            error instanceof msal.BrowserAuthError
          ) {
            msalObj.acquireTokenRedirect(request);
          }
        });
    }

    getMsalObjPromise().then((msalObj) => {
      refreshToken(msalObj);
      setInterval(() => refreshToken(msalObj), TOKEN_REFRESH_INTERVAL_MS);
    });

    const button = document.createElement("button");
    button.textContent = "Log In";
    button.className = "login-btn";
    div.appendChild(button);

    this.on("propertychange", function (e) {
      if (e.key === "idToken" && e.target.get("idToken")) {
        button.textContent = "Logged In";
        button.style.background = "#3CB371";
      }
    });
  }
}
